const placeSelf = {
    name: "place-self",
    path: "/place-self",
    title: "place-self",
    description: "Utilities for setting align-self and justify-self at once in grid layouts.",
    value: {
        "place-self": {
            "place-self-auto": "auto",
            "place-self-start": "start",
            "place-self-center": "center",
            "place-self-center-safe": "safe center",
            "place-self-end": "end",
            "place-self-end-safe": "safe end",
            "place-self-stretch": "stretch",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-rows-2 grid-columns-3 h-64 gap-4">
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">01</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">
    <div class="bg-color-blue-500 text-color-white font-bold rounded-lg w-24 h-24 flex justify-center items-center place-self-center">02</div>
  </div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">03</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">04</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">05</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">06</div>
</div>


<div class="grid grid-rows-2 grid-columns-3 h-64 gap-4">
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">01</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">
    <div class="bg-color-blue-500 text-color-white font-bold rounded-lg w-24 h-24 flex justify-center items-center place-self-end">02</div>
  </div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">03</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">04</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">05</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">06</div>
</div>


<div class="grid grid-rows-2 grid-columns-3 h-64 gap-4">
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">01</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">
    <div class="bg-color-blue-500 text-color-white font-bold rounded-lg flex justify-center items-center place-self-stretch">02</div>
  </div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">03</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">04</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">05</div>
  <div class="bg-color-sky-400 text-color-white flex justify-center items-center rounded-lg h-24">06</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">place-self-*</code> utilities to set both <b>align-self</b> and <b>justify-self</b> at once in grid layouts.
            </p>
            <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">place-self-center</small>
                    <div class="relative">
                        <div class="grid grid-rows-2 grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">01</div>
                            <div class="rounded-lg grid grid-columns-1  border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                                <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-lg w-10 h-10 place-self-center">02</div>
                            </div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">03</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">04</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">05</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-self-end</small>
                    <div class="relative">
                        <div class="grid grid-rows-2 grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">01</div>
                            <div class="rounded-lg grid grid-columns-1  border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                                <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-lg w-10 h-10 place-self-end">02</div>
                            </div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">03</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">04</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">05</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-self-stretch</small>
                    <div class="relative">
                        <div class="grid grid-rows-2 grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">01</div>
                            <div class="rounded-lg grid grid-columns-1  border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                                <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-lg place-self-stretch">02</div>
                            </div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">03</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">04</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">05</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">06</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
    ]
}
export default placeSelf;

<div class="space-y-10 sr-only">
                <div>
                    <small class="text-center block mb-4">place-self-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-rows-2 grid-columns-3 h-64 w-10 h-10 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">01</div>
                            <div class="grid grid-columns-1 bg-color-sky-400 flex justify-center items-center rounded-lg h-24">
                                <div class="bg-color-blue-500 flex justify-center items-center rounded-lg w-24 h-24 place-self-stretch place-self-end place-self-center">02</div>
                            </div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">03</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">04</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">05</div>
                            <div class="bg-color-sky-400 flex justify-center items-center rounded-lg h-24">06</div>
                        </div>
                    </div>
                </div>
            </div>